export default "__VITE_ASSET__97b67196__"